const Home = () => {

  window.location.href = "/public-roles";

  return null;
};

export default Home;
